<template>
  <div :id="elementId">
    <div class="row">
      <div class="col-sm-3">
        <blog-avatar :blog="blog" :w="150" :h="150"/>
      </div>
      <div class="col-sm-9">
        <h3>{{blog.title}}</h3>
        <h5>{{blog.totalPosts}} Posts</h5>
        <h5>
          <a href="#" @click.prevent="showFollower()">{{blog.follower | prettyInt}} Follower <fa-icon :icon="displayFollower ? ['fal','chevron-up'] : ['fal','chevron-down']"/></a>
        </h5>

        <div v-show="displayFollower">
          <loading-indicator name="user.getBlogFollower"/>
          <ul class="user-list">
            <li v-for="user in follower">
              <fa-icon :icon="['fal', 'user']"/>
              {{user.name}}
              <router-link :to="{name:'MessageToUserFromBlog', params: {userId: user._id, blogUrl: blog.url}}"><fa-icon :icon="['fal', 'comment']"/></router-link>

            </li>
          </ul>

          <div>
            <button @click="prevFollowerPage()"
                    class="btn btn-sm btn-outline-primary"
                    :class="{disabled: hasLessFollower}"
                    :disabled="hasLessFollower">
              <fa-icon :icon="['fal', 'chevron-left']"/> prev
            </button>
            <button @click="nextFollowerPage()"
                    class="btn btn-sm btn-outline-primary"
                    :class="{disabled: hasMoreFollower}"
                    :disabled="hasMoreFollower">
              next <fa-icon :icon="['fal', 'chevron-right']"/>
            </button>
            <hr>
          </div>
        </div>

        <p v-if="!isUserBlog" class="options">
          <a :href="getBlogUrl(blog)" @click.prevent="showBlog(blog)"
             class="btn btn-outline-primary"
          >
            <icon icon="external-link"/>
            view
          </a>
          <router-link
            :to="{name: 'EditBlog', params:{blogUrl: blog.url}}"
            class="btn btn-primary"
          >
            <icon icon="pencil"/>
            edit
          </router-link>
          <a href="#" @click.prevent="deleteBlog()" class="btn btn-danger">
            <icon icon="trash-alt" scale="1.5"/>
            delete</a>
        </p>
      </div>

    </div>
    <hr>
  </div>
</template>

<script>

  import Icon from "../../ui/Icon";
  import BlogAvatar from "../../ui/BlogAvatar.vue";
  import LoadingIndicator from "../../ui/LoadingIndicator";

  export default {
    components: {LoadingIndicator, Icon, BlogAvatar},
    props: ['blog'],
    data() {
      return {
        displayFollower: false,
        followerPage: 1,
        follower: [],
        followerPerPage: 25
      }
    },
    created() {
    },
    computed: {
      isUserBlog() {
        return this.blog.url.indexOf('#') === 0;
      },
      elementId(){
        return 'BlogItem-' + this.blog.url;
      },
      hasMoreFollower(){
        return this.follower.length !== this.followerPerPage;
      },
      hasLessFollower() {
        return this.followerPage <= 1
      }
    },
    methods: {
      getBlogUrl(blog) {
        return this.$router.resolve({name: 'BlogPage', params: {blogUrl: blog.url}}).href;
      },
      showBlog(blog) {
        if (this.$route.path !== this.getBlogUrl(blog)) {
          this.$bus.$emit('blog-modal.open', {blog});
        }
      },
      deleteBlog() {
        this.$swal({
          title: 'Delete this Blog?',
          text: 'This Blog will never come back!',
          showCancelButton: true,
          type: 'warning',
          confirmButtonText: 'Yes, delete it!',
          confirmButtonColor: '#d618e7'
        }).then(() => {
          this.$api.deleteBlog(this.blog).then((res) => {
            this.$bus.$emit('blog-deleted');
          })
        }, (dismiss) => {

        });
      },
      showFollower(){
        this.displayFollower = !this.displayFollower;
        if(this.displayFollower) {
          this.loadFollower();
        }
      },
      loadFollower() {
        this.follower = [];
        this.$api.getUserBlogFollower(this.blog, this.followerPage).then(res => {
          this.follower = res.data.follower;
          this.followerPerPage = res.data.perPage;
        })
      },
      nextFollowerPage(){
        if(this.follower.length === this.followerPerPage) {
          this.followerPage++;
          this.loadFollower();
        }
      },
      prevFollowerPage(){
        if(this.followerPage > 1) {
          this.followerPage--;
          this.loadFollower();
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
  .user-list
    padding-left: 0

    li
      list-style-type: none

</style>



// WEBPACK FOOTER //
// src/components/user/blogs/UserBlogListItem.vue